export { default as Text } from './Text';
export type { TextProps, TextVariant } from './types';
